import { useRef, useState } from "react";
import { Paperclip } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { expensesAPI, uploadAPI } from "../lib/api";

// Adds a first receipt to an already-approved expense (e.g. after Autopilot pushed it).
export const AttachReceiptButton = ({ exp, onAttached }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const { data: up } = await uploadAPI.receipt(file);
      const { data } = await expensesAPI.update(exp.id, { receipt_path: up.storage_path });
      toast.success("Receipt attached");
      onAttached?.(data);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Couldn't attach the receipt");
    } finally { setBusy(false); }
  };

  return (
    <>
      <input ref={inputRef} type="file" accept="image/*,application/pdf" className="hidden"
        onChange={handleFile} data-testid="attach-receipt-input" />
      <Button size="sm" variant="outline" disabled={busy} onClick={() => inputRef.current?.click()}
        className="rounded-sm text-xs gap-1" data-testid="attach-receipt-btn">
        <Paperclip size={12} /> {busy ? "Uploading…" : "Add receipt"}
      </Button>
    </>
  );
};
